// Notification sound utility using Web Audio API
let audioContext: AudioContext | null = null
let audioUnlocked = false

function getAudioContext(): AudioContext {
  if (!audioContext) {
    audioContext = new (window.AudioContext || (window as any).webkitAudioContext)()
  }
  return audioContext
}

// Unlock audio context on first user interaction (required by browsers)
function unlockAudio(): void {
  if (audioUnlocked) return

  const ctx = getAudioContext()
  if (ctx.state === 'suspended') {
    ctx.resume()
  }

  // Create a silent buffer to unlock
  const buffer = ctx.createBuffer(1, 1, 22050)
  const source = ctx.createBufferSource()
  source.buffer = buffer
  source.connect(ctx.destination)
  source.start(0)

  audioUnlocked = true
}

// Set up audio unlock on first interaction
if (typeof window !== 'undefined') {
  const events = ['click', 'touchstart', 'keydown']
  const unlockHandler = () => {
    unlockAudio()
    events.forEach((e) => document.removeEventListener(e, unlockHandler))
  }
  events.forEach((e) => document.addEventListener(e, unlockHandler, { once: true }))
}

export function playNotificationSound(): void {
  try {
    const ctx = getAudioContext()

    // Resume audio context if suspended (required by browsers)
    if (ctx.state === 'suspended') {
      ctx.resume()
    }

    const oscillator = ctx.createOscillator()
    const gainNode = ctx.createGain()

    oscillator.connect(gainNode)
    gainNode.connect(ctx.destination)

    // Simple pleasant notification tone
    oscillator.frequency.setValueAtTime(880, ctx.currentTime) // A5 note
    oscillator.type = 'sine'

    // Quick fade in and out for a soft "ding"
    gainNode.gain.setValueAtTime(0, ctx.currentTime)
    gainNode.gain.linearRampToValueAtTime(0.3, ctx.currentTime + 0.01)
    gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.3)

    oscillator.start(ctx.currentTime)
    oscillator.stop(ctx.currentTime + 0.3)
  } catch (error) {
    // Silently fail if audio is not supported
    console.warn('Could not play notification sound:', error)
  }
}

export function isTabHidden(): boolean {
  return document.hidden
}
